import "./style.scss";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

// Hero Banner Cutting Animation - bottom + sides with border radius
const initHeroBannerCutting = () => {
    const heroBanner = document.querySelector('.wp-block-ow-hero-banner');

    if (!heroBanner) {
        return;
    }

    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: heroBanner,
            start: "top top",
            end: "bottom top",
            scrub: 0.5,
            pin: true,
            anticipatePin: 1
        }
    });

    // Animate from 0% to 10% bottom cut with sides
    tl.fromTo(heroBanner,
        {
            clipPath: "inset(0% 0% 0% 0% round 0 0 40px 40px)"
        },
        {
            clipPath: "inset(0% 3% 8% 3% round 0 0 40px 40px)",
            ease: "none",
            duration: 0.2
        }
    )
        // Then animate from 10% to 100% bottom cut, keeping sides at 5%
        .fromTo(heroBanner, {
            clipPath: "inset(0% 3% 8% 3% round 0 0 40px 40px)"
        }, {
            clipPath: "inset(0% 3% 100% 3% round 0 0 40px 40px)",
            ease: "none",
            duration: 0.8
        });
};

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
    initHeroBannerCutting();
});